// Module
var code = "<h1 id=\"admissions\">Admissions</h1> <p>This is where the campus’s different admission stages are setup according to their desired structure.</p> <p>There is no limit to how many stages you can have, but you can only have one stage in the waiting list status.</p> ";
// Exports
module.exports = code;